/**
 * Shared constants for the element prompt builder
 */

// UI Dimensions
export const UI_CONSTANTS = {
  // Menu dimensions
  MENU_WIDTH: 350, // Width of the control menu in pixels
  MENU_HEIGHT: 52, // Height of the control menu in pixels
  
  // Spacing and offsets
  SPACING: 10, // Standard spacing for margins and padding
  ARROW_LEFT_OFFSET: 20, // Left offset for the arrow from menu edge
  
  // Z-index values
  Z_INDEX: 10000, // Standard z-index for UI elements
};
